import { render } from "./TaskSettingForm.vue?vue&type=template&id=f2909852"
import script from "./TaskSettingForm.vue?vue&type=script&lang=js"
export * from "./TaskSettingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__